module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAMCAYAAADGZiUoAAAABGdBTUEAALGPC/xhBQAAALBJREFUSA3dkyESwjAQRf9WonoEdD3HQOIq8NwHzRQckmPgq3sEMLh2aVM6k10moH9idv8kIm92H/DvNLpH0yvO/Sk8Jcryk+2iFQa9Q9ChlA2eWDPlIgl30xVUr+FeZBcqU97KKw33GI4jXAXIAbW0YMvJqRF5FRj8fz9g386Re4ZxHZeh2bXMwLMFbKoWjs0r/9+YzPR+b9mygZnD7FxGnsWMBTLzzML5vWXLMY3r3wUGB+HO68dXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/screen/title-left.png
// module id = ka/o
// module chunks = 1